export const BUSINESS = {
  name: "Kay's Carpet Cleaning",
  phoneDisplay: "0450 311 907",
  phoneHref: "tel:0450311907",
  email: "info@kayscarpetcleaning.com.au",
  emailHref: "mailto:info@kayscarpetcleaning.com.au",
  abn: "29 829 329 207",
  hours: "Monday – Saturday, 8:00 AM – 8:00 PM",
  hoursShort: "Mon – Sat, 8 AM – 8 PM",
  area: "Gold Coast, QLD",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1556593825-c11de986cb0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzV8MHwxfHNlYXJjaHwzfHxwcmlzdGluZSUyMGxpdmluZyUyMHJvb20lMjB3aGl0ZSUyMGNhcnBldHxlbnwwfHx8fDE3ODY2ODIwNTJ8MA&ixlib=rb-4.1.0&q=85",
  sofa: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxjbGVhbiUyMHNvZmElMjB1cGhvbHN0ZXJ5fGVufDB8fHx8MTc4NjY4MjA1Mnww&ixlib=rb-4.1.0&q=85",
  bedroom: "https://images.unsplash.com/photo-1616486029423-aaa4789e8c9a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwyfHxmcmVzaCUyMGNsZWFuJTIwYmVkcm9vbXxlbnwwfHx8fDE3ODY2ODIwNTJ8MA&ixlib=rb-4.1.0&q=85",
  office: "https://images.unsplash.com/photo-1627905646269-7f034dcc5738?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxvZmZpY2UlMjBjbGVhbmluZyUyMGNvbW1lcmNpYWx8ZW58MHx8fHwxNzg2NjgyMDUyfDA&ixlib=rb-4.1.0&q=85",
  cleaner: "https://images.unsplash.com/photo-1740657254989-42fe9c3b8cce?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjbGVhbmluZyUyMHNlcnZpY2V8ZW58MHx8fHwxNzg2NjgyMDUyfDA&ixlib=rb-4.1.0&q=85",
  skyline: "https://images.unsplash.com/photo-1548661625-a30d197ce439?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxicmlzYmFuZSUyMHNreWxpbmV8ZW58MHx8fHwxNzg2NjgyMDUyfDA&ixlib=rb-4.1.0&q=85",
  rug: "https://images.unsplash.com/photo-1600166898405-da9535204843?w=1000&q=80&fm=jpg&fit=crop",
  couchAlt: "https://images.unsplash.com/photo-1567016432779-094069958ea5?w=1000&q=80&fm=jpg&fit=crop",
  coast: "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=1200&q=80&fm=jpg&fit=crop",
};

export const SERVICE_LINKS = [
  { label: "Carpet Cleaning", to: "/carpet-cleaning-brisbane" },
  { label: "Couch & Lounge Cleaning", to: "/couch-cleaning-brisbane" },
  { label: "Rug Cleaning", to: "/rug-cleaning-brisbane" },
  { label: "Mattress Cleaning", to: "/mattress-cleaning-brisbane" },
  { label: "Tile & Grout Cleaning", to: "/tile-grout-cleaning-brisbane" },
  { label: "Commercial Carpet Cleaning", to: "/commercial-carpet-cleaning-brisbane" },
  { label: "Pet Stain & Odour Cleaning", to: "/pet-stain-odour-cleaning-brisbane" },
  { label: "Water & Flood Damage Restoration", to: "/water-flood-damage-restoration-brisbane" },
];

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Carpet Cleaning", to: "/carpet-cleaning-brisbane" },
  { label: "Services", dropdown: true },
  { label: "About", to: "/about" },
  { label: "Service Areas", to: "/service-areas" },
  { label: "FAQs", to: "/faqs" },
  { label: "Contact", to: "/contact" },
];

export const scrollToSection = (href) => {
  const el = document.querySelector(href);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -100, duration: 1.2 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
